exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit4b .exercise .exercise-number_3{padding-top:50px}.unit4b .intro-1 ul{padding-left:80px}.unit4b .intro-1 p:last-child{border-bottom:3px solid #000;padding-bottom:45px;margin-bottom:45px}.unit4b .exercise-title{font-size:42px}.unit4b .intro-3 ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4b .intro-3 p:first-child{text-decoration:underline;font-weight:700;font-size:24px}.unit4b .intro-2 p:first-child{font-weight:700;font-size:24px}.unit4b .intro-2 p:first-child+p{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/courses/4/4b1/findingReadersQuestion/findingReadersQuestion.scss
// module id = 741
// module chunks = 0